import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/retail_management/Login";
import Dashboard from "./pages/retail_management/Dashboard";
import InventoryScanner from "./pages/retail_management/InventoryCount";
import ScannedResult from "./pages/retail_management/ScannedResultPost";
import LandingPage from "./pages/landing_page";

import WhDashbaord from "./pages/warehouse_qc/WH_dashbaord";
import BatchData from "./pages/warehouse_qc/batches_data";
import BatchItemForm from "./pages/warehouse_qc/batch_update_data";

import QualityGallery from "./pages/admin/quality_check";
import RemarksSummary from "./pages/admin/remarks_summary";

import ManagementDashboard from "./pages/InventoryManagement/PlantSystem/LandingDashboard";
import TaskAggregationPage from "./pages/InventoryManagement/PlantSystem/TaskSection";
import TaskPage from "./pages/InventoryManagement/PlantSystem/TaskPage";
import TaskSelectionPage from "./pages/InventoryManagement/PlantSystem/BatchProcessing";
import BatchSubmissionPage from "./pages/InventoryManagement/PlantSystem/BatchSubmission";
import SalesUpload from "./pages/InventoryManagement/PlantSystem/SalesUpload";
import AdminPage from "./pages/InventoryManagement/PlantSystem/Admin";
import BatchExplorer from "./pages/InventoryManagement/PlantSystem/BatchesPage";

import CategoryMaster from "./pages/SkuManagement/CategoryMaster";
import DropdownAdmin from "./pages/SkuManagement/DropdownAdmin";
import NPDMaster from "./pages/SkuManagement/NpdMaster";
import SkuMaster from "./pages/SkuManagement/SkuMaster";
import SkuCreation from "./pages/SkuManagement/SkuCreation";
import UnitEconomics from "./pages/SkuManagement/UnitEconomics";
import ListingMaster from "./pages/SkuManagement/ListingMaster";
import SkuManagementLanding from "./pages/SkuManagement/SkuManagementLanding";
import CatalougeMaster  from "./pages/SkuManagement/CatalougeMaster";
import IskuExplorer from "./pages/SkuManagement/IskuExplorer";
import TestTable from "./pages/SkuManagement/TestTable";

import UserEdit from "./pages/user_permission/UserEdit";
import PartyDetailsPage from "./pages/Purchase/PartyDetails";
import RequirementsSummary from "./pages/Purchase/RequirementsSummary";
import InvoicingDetails from "./pages/Purchase/InvoicingDetails";
import InvoiceProcessing from "./pages/Purchase/InvoiceProcessing";



import { ScanProvider } from "./context/InventoryContext";
import { hasAnyPermission } from "./lib/permissions";

// Requires login only
const ProtectedRoute = ({ element }) => {
  const isAuthenticated = !!localStorage.getItem("token");
  return isAuthenticated ? element : <Navigate to="/login" replace />;
};

// Requires login + at least one of the listed permissions
const PermissionRoute = ({ element, permissions }) => {
  const isAuthenticated = !!localStorage.getItem("token");
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!hasAnyPermission(permissions)) return <Navigate to="/" replace />;
  return element;
};

function App() {
  return (
    <ScanProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="/" element={<ProtectedRoute element={<LandingPage />} />} />
          <Route path="/retail_dashboard" element={<ProtectedRoute element={<Dashboard />} permissions={[ "main_admin.view", "main_admin.edit"]} />} />
          <Route path="/warehouse_dashboard" element={<ProtectedRoute element={<WhDashbaord />} permissions={["quality_check.view", "quality_check.edit"]} />} />
          <Route path="/batches_data" element={<ProtectedRoute element={<BatchData />} permissions={[ "quality_check.view", "quality_check.edit"]}/>} />
          <Route path="/batch/:batchId" element={<ProtectedRoute element={<BatchItemForm />} permissions={[ "quality_check.view", "quality_check.edit"]}/>} />

          <Route path="/secure/quality-check" element={<PermissionRoute element={<QualityGallery />} permissions={["qc_admin.view", "qc_admin.edit", "quality_check.view", "quality_check.edit"]} />} />
          <Route path="/secure/remarks-summary" element={<PermissionRoute element={<RemarksSummary />} permissions={["qc_admin.view", "qc_admin.edit", "quality_check.view", "quality_check.edit"]} />} />

          <Route path="/inventory-count" element={<ProtectedRoute element={<InventoryScanner />} permissions={[ "main_admin.view", "main_admin.edit"]} />} />
          <Route path="/scanned-result" element={<ProtectedRoute element={<ScannedResult />} permissions={[ "main_admin.view", "main_admin.edit"]}/>} />

          <Route path="/inventory-management-dashboard" element={<PermissionRoute element={<ManagementDashboard />} permissions={["inventory.view", "inventory.edit"]} />} />
          <Route path="/task-section" element={<PermissionRoute element={<TaskAggregationPage />} permissions={["inventory.view", "inventory.edit"]} />} />
          <Route path="/layer/:layer" element={<PermissionRoute element={<TaskPage />} permissions={["inventory.view", "inventory.edit"]} />} />
          <Route path="/tasks/filter" element={<PermissionRoute element={<TaskSelectionPage />} permissions={["inventory.view", "inventory.edit"]} />} />
          <Route path="/batch-submission" element={<PermissionRoute element={<BatchSubmissionPage />} permissions={["inventory.edit"]} />} />
          <Route path="/sales-upload" element={<PermissionRoute element={<SalesUpload />} permissions={["inventory.edit"]} />} />
          <Route path="/warehouse-admin-page" element={<PermissionRoute element={<AdminPage />} permissions={["main_admin.view", "main_admin.edit"]} />} />
          <Route path="/batch-viewer" element={<PermissionRoute element={<BatchExplorer />} permissions={["inventory.view", "inventory.edit"]} />} />

          <Route path="/sku-management" element={<PermissionRoute element={<SkuManagementLanding />} permissions={["sku_management.view", "sku_master.view", "sku_creation.view", "category_master.view", "npd_master.view", "unit_economics.view", "listing_master.view", "catalouge_master.view", "isku_explorer.view", "dropdown_admin.view"]} />} />
          <Route path="/sku-management/sku-master" element={<PermissionRoute element={<SkuMaster />} permissions={["sku_master.view", "sku_master.edit"]} />} />
          <Route path="/sku-management/sku-creation" element={<PermissionRoute element={<SkuCreation />} permissions={["sku_creation.view", "sku_creation.create"]} />} />
          <Route path="/sku-management/category" element={<PermissionRoute element={<CategoryMaster />} permissions={["category_master.view", "category_master.edit"]} />} />
          <Route path="/sku-management/npd" element={<PermissionRoute element={<NPDMaster />} permissions={["npd_master.view", "npd_master.edit"]} />} />
          <Route path="/sku-management/unit-economics" element={<PermissionRoute element={<UnitEconomics />} permissions={["unit_economics.view", "unit_economics.edit"]} />} />
          <Route path="/sku-management/listing-master" element={<PermissionRoute element={<ListingMaster />} permissions={["listing_master.view", "listing_master.edit"]} />} />
          <Route path="/sku-management/catalouge-master" element={<PermissionRoute element={<CatalougeMaster />} permissions={["catalouge_master.view", "catalouge_master.edit"]} />} />
          <Route path="/sku-management/isku-explorer" element={<PermissionRoute element={<IskuExplorer />} permissions={["isku_explorer.view", "isku_explorer.edit"]} />} />
          <Route path="/sku-management/dropdown-admin" element={<PermissionRoute element={<DropdownAdmin />} permissions={["dropdown_admin.view", "dropdown_admin.edit"]} />} />
          <Route path="/sku-management/test-table" element={<PermissionRoute element={<TestTable />} permissions={["sku_master.view", "sku_master.edit"]} />} />

          <Route
            path="/purchase/party-details"
            element={<PermissionRoute element={<PartyDetailsPage />} permissions={["purchase_admin.view", "purchase_admin.edit"]} />}
          />
          <Route
            path="/purchase/requirements"
            element={<PermissionRoute element={<RequirementsSummary />} permissions={["purchase_admin.view", "purchase_admin.edit"]} />}
          />
          <Route
            path="/purchase/invoicing"
            element={<PermissionRoute element={<InvoicingDetails />} permissions={["purchase_admin.view", "purchase_admin.edit", "purchase_vendor.view", "purchase_vendor.edit", "purchase_user.view", "purchase_user.edit"]} />}
          />
          <Route
            path="/purchase/invoicing/process"
            element={<PermissionRoute element={<InvoiceProcessing />} permissions={["purchase_admin.view", "purchase_admin.edit", "purchase_vendor.view", "purchase_vendor.edit", "purchase_user.view", "purchase_user.edit"]} />}
          />

          <Route path="/admin/user-permissions" element={<PermissionRoute element={<UserEdit />} permissions={["main_admin.view", "main_admin.edit"]} />} />

        </Routes>
      </Router>
    </ScanProvider>
  );
}

export default App;
